if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const isBuyNow = evt.submitter.classList.contains('custom_buy_now');
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

       evt.submitter.setAttribute("aria-disabled", true);
        evt.submitter.classList.add("loading");
        if (evt.submitter.querySelector(".loading-overlay__spinner"))
          evt.submitter
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        document.querySelectorAll('.extra_product_checkbox:checked').forEach((item, index)=> {
          formData.append(`items[${index}]id`,item.dataset.id);
          formData.append(`items[${index}]quantity`,item.dataset.quantity);
        });
        
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.querySelector(".custom_buy_now").setAttribute(
                "disabled",
                ""
              );
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // this.error = false;
            // const quickAddModal = this.closest("quick-add-modal");
            // if (quickAddModal) {
            //   document.body.addEventListener(
            //     "modalClosed",
            //     () => {
            //       setTimeout(() => {
            //         this.cart.renderContents(response, evt.submitter);
            //       });
            //     },
            //     { once: true }
            //   );
            //   quickAddModal.hide(true);
            // }
            //  else {
            //   this.cart.renderContents(response, evt.submitter);
            // }
            this.error = false;

            // BUY NOW
            // if (isBuyNow) {
            //   window.location.href = '/checkout';
            //   return;
            // }

            if (isBuyNow) {
              fetch("/cart.js")
                .then((res) => res.json())
                .then((cart) => {
                  // total_price is in paise
                  const cartTotal = cart.total_price / 100;

                  if (cartTotal >= 500) {
                    window.location.href = "/checkout";
                  } else {
                    // Open cart drawer so user can add more products
                    this.cart.renderContents(response, evt.submitter);
                    this.cart.open();
                  }
                });

              return;
            }

            // ADD TO CART
            const quickAddModal = this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, evt.submitter);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, evt.submitter);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            evt.submitter.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) evt.submitter.removeAttribute("aria-disabled");
            if (evt.submitter.querySelector(".loading-overlay__spinner"))
              evt.submitter
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    } 
  );
}
